import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { combineClassNames } from '@utils/combineClassNames';
import { TRIAL_WORDMARK } from './trial-media';

const STEPS = ['company', 'brand', 'modules'] as const;

type Props = {
  current: number;
  domain: string;
};

export const SetupChrome = memo(({ current, domain }: Props) => {
  const { t } = useTranslation();

  return (
    <header
      className={
        'FreeTrial__Chrome max-md:!tw-left-4 max-md:!tw-right-4 max-md:!tw-top-[18px] '
        + 'max-md:!tw-flex-col max-md:!tw-gap-3.5'
      }
    >
      <div className="FreeTrial__Chrome__Brand">
        <img src={TRIAL_WORDMARK} alt="" />
      </div>
      <nav
        className={
          'FreeTrial__Progress max-md:!tw-grid max-md:!tw-w-full max-md:!tw-grid-cols-3 '
          + 'max-md:!tw-gap-1.5'
        }
        aria-label={t('authentication:trial_setup_eyebrow', { current, total: 3 })}
      >
        {STEPS.map((key, index) => {
          const step = index + 1;
          const isDone = step < current;
          const isCurrent = step === current;

          return (
            <div key={key} className="FreeTrial__Progress__Item max-md:!tw-w-auto">
              <span className={combineClassNames('FreeTrial__Progress__Bar', {
                'FreeTrial__Progress__Bar--done': isDone,
                'FreeTrial__Progress__Bar--current': isCurrent,
              })}
              >
                {isCurrent && <span />}
              </span>
              <span className={combineClassNames('FreeTrial__Progress__Label', {
                'FreeTrial__Progress__Label--active': step <= current,
              })}
              >
                {isDone ? '✓ ' : ''}
                {t(`authentication:trial_setup_step_${key}`)}
              </span>
            </div>
          );
        })}
      </nav>
      <div className="FreeTrial__Chrome__Status max-md:tw-hidden">
        <span>
          <i />
          {t('authentication:trial_setup_still_building', { domain })}
        </span>
      </div>
    </header>
  );
});
